import { render, staticRenderFns } from "./GlobalGapReport.vue?vue&type=template&id=31e5f24e&scoped=true&"
import script from "./GlobalGapReport.vue?vue&type=script&lang=js&"
export * from "./GlobalGapReport.vue?vue&type=script&lang=js&"
import style0 from "./GlobalGapReport.vue?vue&type=style&index=0&id=31e5f24e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e5f24e",
  null
  
)

export default component.exports